<template>
   <div id="movie-manage" style="height: 700px; overflow-y: scroll;">

      <!--表格-->
      <div class="banner-table">
      <el-table border :data="tableData"  stripe border :span-method="arraySpanMethod">
        <el-table-column label="一级分类名称" width="180" align="center" prop="level1"></el-table-column>

        <el-table-column label="️二级分类名称" width="180" align="center" prop="level2"></el-table-column>

        <el-table-column label="三级分类名称" width="180" align="center" prop="level3" ></el-table-column>

        <el-table-column label="股票名称" width="180" align="center" prop="stock">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.color === 1 ? 'blue' : 'red' }">{{ scope.row.stock }}</span>
          </template>
        </el-table-column>
        <el-table-column label="股票分类" width="180" align="center" prop="category"></el-table-column>
        <el-table-column label="股票描述" width="200" align="center" prop="abs"></el-table-column>
        <el-table-column width="300" size="mini"  align="center"  label="产业链操作">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="primary" @click="addBanner(scope.$index, scope.row)">新增</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

      <!--弹框-->
      <div>
        <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          v-if="dialogFormVisible"
          :showClose="false"
        >
          <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="bannerInfo">

            <el-form-item label="一级分类" prop="firstTitle" >
              <el-col :span="16">
                <el-input v-model="bannerInfo.level1" :disabled="bannerInfo.able"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="二级分类" prop="firstTitle">
              <el-col :span="16">
                <el-input v-model="bannerInfo.level2" :disabled="bannerInfo.able"></el-input>
              </el-col>
            </el-form-item>


            <el-form-item label="三级分类" prop="firstTitle">
              <el-col :span="16">
                <el-input v-model="bannerInfo.level3" :disabled="bannerInfo.able"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="股票名称" prop="firstTitle">
              <el-col :span="16">
                <el-input v-model="bannerInfo.stock"></el-input>
              </el-col>
            </el-form-item>





            <el-form-item label="股票介绍" prop="firstTitle" v-if="bannerInfo.able">
              <el-col :span="16">
                <el-input v-model="bannerInfo.abs"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="manageBannerInfo()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
</template>

<script>
    import {getBanner,updateBannerInfo,addBannerInfo,deleteBannerInfo} from '../../../api/index'
    import {MessageBox,Message} from 'element-ui'
    import mergeCell from "../../../api/mergeCell";
    export default {
        name: "BannerManage",
        data() {
          return {
            tableData:[],
            formattedData:[],
            mergeArray:[],
            total:0,
            data_len:3,
            currentPage:1,
            bannerInfo: {},
            dialogFormVisible:false,
            dialogTitle:'编辑产业链信息',
            labelPosition:'right',
            url_id:"",
            input:'',
            level1:'',
            level2:'',
            level3:'',
            searchInput:'',

            rules:{
                img: [
                    { required: true, message: '广告图片不能为空', trigger: 'blur' },
                ]
            }
          }
        },
        created() {
          console.log(111)
          const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
          const urlParams = new URLSearchParams(query);
          this.url_id = urlParams.get('id');
          this.loadCurrentPageBanner(this.url_id);
        },
        mounted() {
          this.formatData();
        },
        methods: {

          merge(data,data_len) {
            if (data_len ===  3){
              this.mergeArray = mergeCell(['level1','level2','level3'], data);
            } else {
              this.mergeArray = mergeCell(['level1','level2'], data);
            }

},

          arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex < this.mergeArray.length) {
              const _row = this.mergeArray[columnIndex][rowIndex];
              const _col = _row > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
              return {
                rowspan: _row,
                colspan: _col
              };
            }
          },

          async loadCurrentPageBanner(id){
            let json = await getBanner(id);
            if (json.code===200){
              Message.success(json.msg);
              this.tableData = json.data;
              this.data_len = json.data_len;
              this.merge(this.tableData,this.data_len);
            }
          },

          async handleEdit(index, row) {
            this.dialogTitle = '编辑产业链信息';
            this.bannerInfo = row;
            this.dialogFormVisible = true;
            console.log(index, row);
          },
          addBanner(index, row){
            this.dialogTitle = '添加产业链信息';
            this.bannerInfo = row;
            this.bannerInfo.stock = '';
            this.bannerInfo.able = 'yes';
            this.dialogFormVisible = true;
          },
          async handleDelete(index, row) {
            MessageBox.confirm('此操作将永久删除该产业链下股票信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
                const urlParams = new URLSearchParams(query);
                this.url_id = urlParams.get('id');
                let json;
                if (row.level2 === '') {
                  json = await deleteBannerInfo(row.level2_id);
                } else {
                  json = await deleteBannerInfo(row.level3_id);
                }
                if (json.code===200){
                  this.loadCurrentPageBanner(this.url_id);
                  Message.success('删除该股票成功！');
                } else {
                  Message.success(json.msg);
                }
              }
            });
          },

          changeImg(e){
            let reader = new FileReader();
            console.log(this.$refs.uploadImg.files);
            reader.readAsDataURL(this.$refs.uploadImg.files[0]);
            let _this = this;
            reader.onload = function(){
              _this.$refs.previewImg.src = this.result;
              _this.bannerInfo.img = this.result;
            }
          },

          async manageBannerInfo(){
               if (this.dialogTitle==='编辑产业链信息'){
                 this.level1  = this.bannerInfo.level1;
              this.level2  = this.bannerInfo.level2;
              this.level3  = this.bannerInfo.level3;
              if (this.level1) {
                console.log(this.bannerInfo)
                let json = await updateBannerInfo(this.bannerInfo);
                if (json.code===200){
                  this.dialogFormVisible = false;
                  Message.success('修改产业链信息成功！');
                } else{
                  Message.error(json.msg);
                }
              } else{
                Message.error('请完成必填内容！');
                }
               }
               else {
                 this.level1  = this.bannerInfo.level1;
              this.level2  = this.bannerInfo.level2;
              this.level3  = this.bannerInfo.level3;
              this.stock  = this.bannerInfo.stock;
              if (this.stock) {
                console.log(this.bannerInfo)
                let json = await addBannerInfo(this.bannerInfo);
                if (json.code===200){
                  this.dialogFormVisible = false;
                  Message.success('新增产业链信息成功！');
                } else{
                  Message.error(json.msg);
                }
              } else{
                Message.error('请完成必填内容！');
                }
               }
               const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
              const urlParams = new URLSearchParams(query);
              this.url_id = urlParams.get('id');
              this.loadCurrentPageBanner(this.url_id);

        },

          cancel(){
            this.dialogFormVisible = false;
            const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
            const urlParams = new URLSearchParams(query);
            this.url_id = urlParams.get('id');
            this.loadCurrentPageBanner(this.url_id);
          }
        },
    }
</script>

<style>
  .banner-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    /* margin-left: auto; */
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    padding-left: 20%;
  }
.upload-imgs{margin: 10px 0 30px 0;overflow: hidden;font-size: 0;}
.upload-imgs li{position: relative;width: 150px;height: 90px;font-size: 14px;display: inline-block;margin-right: 25px;text-align: center;vertical-align: middle;}
.upload-imgs .img{position: relative;width: 94px;height: 94px;line-height: 94px;}
.upload-imgs .img img{vertical-align: middle;}
.upload-imgs .img .close{display: none;}
.upload-imgs li:hover .img .close{display: block;position: absolute;right: -50px;top: 5px;line-height: 1;font-size: 22px;color: #fff;}
</style>




// WEBPACK FOOTER //
// src/pages/Home/children/BannerManage.vue